import styled from '@emotion/styled';

const GetInTouchBannerWrapper = styled.div`
  display: none;
  flex-direction: column;
  text-align: center;
  align-items: center;
  background: white;
  position: absolute;
  right: 24px;
  top: 130px;
  width: 354px;
  padding: 16px;

  @media (min-width: ${(props) => props.theme.breakpoints.mobile_landscape}) {
    display: flex;

    &.point-selected {
      display: none;
    }
  }

  .header {
    display: flex;
    flex-direction: column;
    align-items: center;

    @media (min-width: ${(props) => props.theme.breakpoints.mobile_landscape}) {
      display: flex;
      flex-direction: row-reverse;
    }

    .avatar {
      width: 60px;
      margin: 0 16px 0 0;

      @media (min-width: ${(props) => props.theme.breakpoints.mobile_landscape}) {
        margin: 0 16px 0 0;
      }
    }

    .title {
      text-align: left;
      line-height: 30px;
    }
  }

  .CTA {
    margin-top: 16px;
    padding: 0 1rem;

    @media (min-width: ${(props) => props.theme.breakpoints.mobile_landscape}) {
      width: 322px;
    }
  }

  .mt0 {
    margin-top: 0;
  }
`;

export { GetInTouchBannerWrapper };
